export default { root: { borderWidth: 0 } };
